import gql from 'graphql-tag';

export default gql`
  mutation updateAMSubscriptionAcademicThresholds($input:updateAMSubscriptionAcademicThresholdsInput!) {
    updateAMSubscriptionAcademicThresholds(input:$input) {
      defaults {
        id
        version
        institution
        academicThresholds {
          gpa
          sat
          act
        }
      }
      subscriptions {
        id
        version
        academicThreshold {
          enabled
          thresholds {
            gpa
            sat
            act
          }
        }
      }
    }
  }
`;
